<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ this.data.add === true ? "ADD NEW" : "UPDATE" }} ITEM</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div >

        <div class="img-container w-full mx-auto flex items-center justify-center">
          <img :src="dataImg"  alt="img" class="responsive" :class="imgCss">
        </div>
        <div class="upload-img mt-5 text-center p-6">
          <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" name="content-image" accept="image/*" />
          <vs-button @click="$refs.uploadImgInput.click()">Upload Image</vs-button>
          <vs-button type="flat" color="#999" @click="(() => {
            dataImg = require('@/assets/images/pages/register/upload_image.png')
            imgCss = 'm-w-150'
          })">Remove Image</vs-button>
          <div class="text-danger text-sm" v-show="errors.has('content-image')">{{ errors.first('content-image') }}</div>
        </div>
      </div>
      <div class="p-6">
        <!-- NAME -->
        <vs-input label="Name" v-model="name" class="mt-5 w-full" name="item-name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>

        <vs-input label="Short Content" v-model="shortContent" class="mt-5 w-full" name="item-short-content" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-short-content')">{{ errors.first('item-short-content') }}</span>

       <vs-input label="Long Content" v-model="longContent" class="mt-5 w-full" name="item-long-content" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-long-content')">{{ errors.first('item-long-content') }}</span>

        <!-- CATEGORY -->
        <div class="mt-5 w-full">
          <label class="vs-input--label">Property Type</label>
          <v-select v-model="contentType" class="w-full rounded-lg cursor-pointer" placeholder="Please select"
                    :clearable="false" name="content-type" v-validate="'required'" :options="content_type_options"/>
          <span class="text-danger text-sm" v-show="errors.has('content-type')">{{ errors.first('content-type') }}</span>
        </div>

      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {
      id: null,
      name: '',
      shortContent: '',
      longContent: '',
      imgCss: 'm-w-150',
      dataImg: require('@/assets/images/pages/register/upload_image.png'),
      uploadImg: null,
      contentType: null,
      content_type_options: [
        {label: 'Page', value: 'page'},
        {label: 'Slide', value:'slide'}
      ],
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  mounted () {

  },
  watch: {
    isSidebarActive (val) {
      if (!val) return

      if (this.data.add === true) {
        this.initValues()
        this.$validator.reset()
        this.imgCss = 'm-w-150'
      } else {
        const { name, id, contentType, shortContent, longContent, contentImageUrl } = JSON.parse(JSON.stringify(this.data))
        this.id = id
        this.name = name
        this.contentType = contentType
        this.shortContent = shortContent
        this.longContent = longContent
        this.dataImg = (contentImageUrl !== null) ? contentImageUrl : require('@/assets/images/pages/register/upload_image.png')
        this.imgCss = ''
        this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.name && this.shortContent && this.longContent && this.contentType && (this.uploadImg || this.dataImg.includes('www'))
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
          this.imgCss = ''
        }
        reader.readAsDataURL(input.target.files[0])
        this.uploadImg = input.target.files[0]
      }
    },
    initValues () {
      if (this.data.id) return
      this.id = null
      this.name = ''
      this.shortContent = ''
      this.longContent = ''
      this.dataImg = require('@/assets/images/pages/register/upload_image.png')
      this.imgCss = 'm-w-150'
    },
    submitData () {

      this.$validator.validateAll().then(result => {
        this.$vs.loading()
        if (result) {
          const obj = {
            contentType: this.contentType.value,
            name: this.name,
            shortContent: this.shortContent,
            longContent: this.longContent,
            contentImage: this.uploadImg,
            contentId: this.id
          }

          this.$store.dispatch('api/uploadContent', obj,  event => {
            this.progress = Math.round((100 * event.loaded) / event.total)
          }).then((response) => {
            this.$vs.notify({
              title: 'Content Saved',
              text: response.data.message,
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
            this.$vs.loading.close()
          }).catch(err => {
            console.error(err)
            this.$vs.notify({
              title: 'Error',
              text: err.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            this.$vs.loading.close()
          })

        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .m-w-150 {
    max-width: 150px;
  }
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
  }
</style>
